/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit NotesInput/view.blocks to change it.
import Content from './Content/index'
import NoteTemplate from './NoteTemplate/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function NotesInput({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/New/AdditionalOptions/Content/AddNoteAction/Content/NotesInput"
  
}) {
  return (<React.Fragment
>
<Content
  viewPath={`${viewPath}/Content`}
/>
<NoteTemplate
  viewPath={`${viewPath}/NoteTemplate`}
/>
{children}
</React.Fragment>)
}